import { Button, Dialog, DialogActions, DialogContent, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import { Worker, Viewer, SpecialZoomLevel } from "@react-pdf-viewer/core";
import { toolbarPlugin, ToolbarSlot } from "@react-pdf-viewer/toolbar";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "./PdfViewer.css";
import { useEffect, useState } from "react";
import Loader from "../../../components/Loader";
import { CancelOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

var signatures = {
  JVBERi0: "application/pdf",
  R0lGODdh: "image/gif",
  R0lGODlh: "image/gif",
  iVBORw0KGgo: "image/png",
  "/9j/": "image/jpg",
};

function PDFViewer(props) {
  const [loading, setLoading] = useState(false);
  const [previewFile, setPreviewFile] = useState("");
  const toolbarPluginInstance = toolbarPlugin();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { Toolbar } = toolbarPluginInstance;
  const { t } = useTranslation();

  useEffect(() => {
    if (props.url) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [props.url]);

  function clearFieldsAndCloseDialog() {
    props.handleClosePdfViewer();
  }

  function detectMimeType(b64) {
    for (var s in signatures) {
      if (b64?.indexOf(s) === 0) {
        return signatures[s];
      }
    }
  }
  const preViewOrDownload = (text) => {
    setPreviewFile(text);
    if (text === "yes") {
      window.open(`data:application/text;base64,${props.url}`);
    }
  };
  const renderContent = () => {
    if (detectMimeType(props.url) === "application/pdf") {
      return (
        <div className="pdf-viewer-root rpv-core__viewer">
          <div className="pdf-viewer-toolbar">
            <Toolbar>
              {(props: ToolbarSlot) => {
                const {
                  CurrentPageInput,
                  Download,
                  EnterFullScreen,
                  GoToNextPage,
                  GoToPreviousPage,
                  NumberOfPages,
                //   Print,
                  // ShowSearchPopover,
                  Zoom,
                  ZoomIn,
                  ZoomOut,
                } = props;
                return (
                  <>
                    {/* <div style={{ padding: "0px 2px" }}>
                      <ShowSearchPopover />
                    </div> */}
                    <div style={{ padding: "0px 2px" }}>
                      <ZoomOut />
                    </div>
                    <div style={{ padding: "0px 2px" }}>
                      <Zoom />
                    </div>
                    <div style={{ padding: "0px 2px" }}>
                      <ZoomIn />
                    </div>
                    <div style={{ padding: "0px 2px", marginLeft: "auto" }}>
                      <GoToPreviousPage />
                    </div>
                    <div style={{ padding: "0px 2px", width: "4rem" }}>
                      <CurrentPageInput />
                    </div>
                    <div style={{ padding: "0px 2px" }}>
                      / <NumberOfPages />
                    </div>
                    <div style={{ padding: "0px 2px" }}>
                      <GoToNextPage />
                    </div>
                    <div style={{ padding: "0px 2px", marginLeft: "auto" }}>
                      <EnterFullScreen />
                    </div>
                    <div style={{ padding: "0px 2px" }}>
                      <Download />
                    </div>
                    <div
                      style={{
                        padding: "0px 2px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      {/* <Print />{" "} */}
                      <Tooltip title="Close this dialog">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                            width: "100%",
                            cursor: "pointer",
                          }}
                        >
                          <CancelOutlined
                            onClick={() => clearFieldsAndCloseDialog()}
                          />
                        </div>
                      </Tooltip>
                    </div>
                  </>
                );
              }}
            </Toolbar>
          </div>
          <div className="pdf-viewer-body">
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
              {props.url !== undefined ? (
                <Viewer
                  fileUrl={`data:application/pdf;base64,${props.url}`}
                  plugins={[toolbarPluginInstance]}
                  defaultScale={SpecialZoomLevel.PageWidth}
                />
              ) : (
                ""
              )}
            </Worker>
          </div>
        </div>
      );
    } else if (
      detectMimeType(props.url) === "image/png" ||
      detectMimeType(props.url) === "image/jpg" ||
      detectMimeType(props.url) === "image/gif"
    ) {
      return (
      <div className="pdf-viewer-image-wrap">
        <img
          src={`data:image/png;base64,${props?.url}`}
          className="pdf-viewer-image"
          alt="Attachment preview"
        />
      </div>
      );
    } else if(props?.url !== undefined) {
      let data = {
        ID: 948201,
        name: "someText",
        description: ".txt",
        base64File: props?.url,
      };
      let decodedText = atob(data?.base64File);
      return (
        <div className="pdf-viewer-text-wrap">
          {previewFile !== "no" && (
            <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center"
            }}
            >
              <span>{t("Please continue by selecting an option")}&nbsp;</span>
              <a
                onClick={() => preViewOrDownload("no")}
                className="previewHereButton"
                style={{marginLeft: 0}}
              >
                {t("Preview")}
              </a>
              <a
                onClick={() => preViewOrDownload("yes")}
                className="button"
              >
                {t("Download")}
              </a>
            </div>
          )}
          {previewFile === "no" && <pre>{decodedText}</pre>}
        </div>
      );
    }
  };

  if (loading) {
    return <Loader open={loading} />;
  } else {
    return (
      <Dialog
        open={props.open}
        fullScreen={fullScreen}
        fullWidth
        maxWidth="lg"
        BackdropProps={{ style: { opacity: 0.4 } }}
        PaperProps={{
          elevation: 0,
          className: fullScreen
            ? "pdf-viewer-dialog-paper pdf-viewer-dialog-paper--fullscreen"
            : "pdf-viewer-dialog-paper",
        }}
      >
        <DialogContent className="pdf-viewer-dialog-content" style={{ overflow: "hidden", padding: fullScreen && 0  }} dividers>
          {renderContent()}
        </DialogContent>
        <DialogActions className="pdf-viewer-dialog-actions">
          <Button
            className="createButton"
            onClick={() => clearFieldsAndCloseDialog()}
          >
            {t("Close")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default PDFViewer;
